/* eslint-disable no-undef */
/* eslint-disable max-statements */
/* eslint-disable complexity */
/* eslint-disable no-console */
import axios from "axios";
import interceptor from "./interceptor";
import { middlewareConstants } from "./middleware-constants";
import { vehicleApiUrl } from "../constants/url-constants";
import { getDeviceType } from "../utils/helpers/device-type";
import { userClientIdInstance } from "../utils/helpers/generate-client-id";
import { getCookiesValueObjectFromKeys } from "../utils/helpers/get-cookie-values-object-from-keys";
import { HTTP_CODES, NUMBER } from "../constants/app-constants";
import { configureBifrostAuth, getUserState, refreshToken, tokenState } from "./token-refresh-manager";
import jwtDecode from "jwt-decode";
import { reducerManager } from "../reducer-manager";

const VEHICLE_SERVICE_BASE_API_URL = `${vehicleApiUrl()}/`;
const WAIT_TIME_IN_SECS = NUMBER.THIRTY;

// Re-export for backward compatibility
export { tokenState };

const middlewareConfig = (middlewareKey) => {
    const params = middlewareConstants[middlewareKey];
    const {
        baseApi = "",
        authKey = "",
        customHeaders,
        withCredentials = false,
        isVersion = false,
        isSource = false,
        isTokenValidCheckEnable = false,
        debugEnv = "development2",
        isClientId = false,
        isCityId = false
    } = params;
    const DEBUG = process.env.NODE_ENV === debugEnv;
    const api = axios.create({
        baseURL: baseApi,
        headers: {
            "Content-Type": "application/json",
            ...(authKey && { "x_basic_a": `Basic ${authKey}` }),
            ...(customHeaders && {...customHeaders})
        },
        ...(withCredentials && { withCredentials: true })
    });
    const cookiesKeys = ["statsigStableId", "user_selected_city"];

    // eslint-disable-next-line max-statements
    api.interceptors.request.use(async (config) => {

        if (config.headers.Authorization) {
            const authToken = (config.headers.Authorization && config.headers.Authorization.split(" ")[1]) || null;

            if (authToken) {
                const userState = getUserState();
                const currentRefreshToken = userState?.refreshToken;
                const currentSessionId = userState?.sessionId;
                const currentAccessToken = userState?.secureToken;

                const authTokenDecoded = await jwtDecode(currentAccessToken);
                const currentTimeInSec = new Date().getTime() / NUMBER.THOUSAND;

                // update access token when expiry time is less than 30 secs
                if (authTokenDecoded && ((authTokenDecoded.exp - currentTimeInSec) < WAIT_TIME_IN_SECS)) {
                    try {

                        const refreshResponse = await refreshToken(currentRefreshToken, currentSessionId);
                        const data = refreshResponse?.data?.data || {};

                        const newAccessToken = data.access_token;
                        const newRefreshToken = data.refresh_token;
                        const newSessionId = data.session_id;

                        // Update Redux store
                        reducerManager.getDispatch()({
                            type: "configuration/SET_BIFROST_TOKENS",
                            secureToken: newAccessToken,
                            refreshToken: newRefreshToken,
                            sessionId: newSessionId
                        });

                        await configureBifrostAuth({
                            bifrostToken: newAccessToken,
                            refreshToken: newRefreshToken,
                            sessionId: newSessionId,
                            expiresIn: data.expires_in,
                            refreshTokenExpiryIn: data.refresh_token_expiry_in
                        });

                        config.headers.Authorization = `Bearer ${newAccessToken}`;
                    } catch (err) {
                        console.error("Error refreshing token::", err);
                    }
                } else if (authTokenDecoded && ((authTokenDecoded.exp - currentTimeInSec) > WAIT_TIME_IN_SECS)) {
                    config.headers.Authorization = `Bearer ${currentAccessToken}`;
                }
            }
        }

        const cookiesValues = getCookiesValueObjectFromKeys(cookiesKeys);
        const {statsigStableId, user_selected_city: cityId} = cookiesValues || {};
        if (isVersion) {
            config.baseURL = `${baseApi}${config.version || "v1"}/`;
        }
        if (config.isMigrated && (process.env.HOST_ENV === "QA" || process.env.HOST_ENV === "STAGING" || process.env.HOST_ENV === "PRODUCTION")) {
            config.baseURL = VEHICLE_SERVICE_BASE_API_URL;
            if (config.headers && config.headers["X-Application-Type"]) {
                delete config.headers["X-Application-Type"];
            }
            config.withCredentials = false;
        }
        if (isSource && getDeviceType().source) {
            config.headers.common.SOURCE = getDeviceType().source;
        }
        if (isClientId) {
            if (userClientIdInstance.userClientId.clientId) {
                config.headers.clientId = userClientIdInstance.userClientId.clientId;
            }
            if (statsigStableId) {
                config.headers.x_experiment_id = statsigStableId;
            }
        }
        if (isCityId) {
            config.headers["x-user-city-id"] = cityId || "";
        }
        /** In dev, intercepts request and logs it into console for dev */
        if (DEBUG) { console.info("✉️ ", config); }
        return config;
    }, (error) => {
        if (DEBUG) { console.error("✉️ ", error); }
        return Promise.reject(error);
    });

    /**
     * Passes response.data to services.
     * In dev, intercepts response and logs it into console for dev
     */
    api.interceptors.response.use((response) => {
        let validResponse = response;
        if (response.config.parse) {
            validResponse = interceptor(response);
        }
        if (DEBUG) { console.info(`📩 ${response.config.url}`, {validResponse, response}); }
        return validResponse;
    }, (error) => {
        // if ([HTTP_CODES.UNAUTHORIZED].includes(error.response?.status)) {
        //     return Promise.reject(error);
        // }
        if (error.config && error.config.customError) return Promise.reject(error);
        if (error.response && error.response.data) {
            if (DEBUG) { console.error("Error: ", error.response.data); }
            return Promise.reject(error.response.data);
        }
        if (isTokenValidCheckEnable) {
            if (error.response?.status === HTTP_CODES.UNAUTHORIZED) {
                tokenState.isTokenValid = false;
            } else {
                tokenState.isTokenValid = true;
            }
        }
        if (DEBUG) { console.error("📩 ", error); }
        return Promise.reject(error.message);
    });
    // setupAuthRefreshInterceptor(api);
    return api;
};

export default middlewareConfig;
